// styles
import styled from 'styled-components';
import SoFormCandidateBlockDetailsInputsEconomy from './SoFormCandidateBlockDetailsInputsEconomy';
import SoFormCandidateBlockDetailsInputsExpress from './SoFormCandidateBlockDetailsInputsExpress';
import SoFormCandidateBlockDetailsInputsStandard from './SoFormCandidateBlockDetailsInputsStandard';
import { isFlexLikeProduct } from 'refactored/features/soForm/productTypes';

const SoFormCandidateBlockDetailsInputs = ({ candidate, className }) => {
  return (
    <div className={className}>
      {candidate.productType === 'EXPRESS' && (
        <SoFormCandidateBlockDetailsInputsExpress candidate={candidate} />
      )}
      {isFlexLikeProduct(candidate.productType) && (
        <SoFormCandidateBlockDetailsInputsStandard candidate={candidate} />
      )}
      {candidate.productType === 'ECONOMY' && (
        <SoFormCandidateBlockDetailsInputsEconomy candidate={candidate} />
      )}
    </div>
  );
};

export default styled(SoFormCandidateBlockDetailsInputs)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;

  position: relative;
  width: 600px;

  /* secondary / white */

  background: #ffffff;
  border-radius: 4px;
`;
